import countries from "../Data/countries.json";
import { get_user_auth } from "../Controllers/Layouts/Layouts";

const getCountryCurrencyCode = async () => {
  try {
    const userData = await get_user_auth();
    console.log("User Data:", userData);
    const countryName = userData?.data?.branch?.country;

    if (!countryName) return "";

    const country = countries.find(
      (c) => c.country.toLowerCase() === countryName.toLowerCase()
    );

    return country ? country.code : "";
  } catch (error) {
    console.error("Error fetching country currency code:", error);
    return "";
  }
};

export default getCountryCurrencyCode;